__turbopack_context__.v({
  "className": "caveat_52e901c8-module__VlCBqW__className",
});
